<template>
  <div id="growing_components" class="p-42 my-52 growing-container fc-15253C">
    <div class="relative">
      <div
        @click.prevent="showVideo"
        class="absolute-header"
        style="top: -17px; right: 0"
      >
        <div class="button-header flex-mid">
          <i class="el-icon-caret-right"></i>
        </div>
      </div>
    </div>
    <div class="fs-18 fw-900">
      {{ $t("weQuarterlyInsights.growing.howAreWe") }}
    </div>
    <div class="flex">
      <div v-if="user.boss" class="opa-07 fc-15253C">
        {{ $t("weQuarterlyInsights.growing.progressBasedOnBoss") }}
      </div>
      <div v-else class="opa-07 fc-15253C">
        {{ $t("weQuarterlyInsights.growing.progressBasedOn") }}
      </div>
      <!-- <div class="ml-auto flex fs-12" style="width: 200px">
        <div
          @click.prevent="activeGrowingTab = 'directReports'"
          :class="`tab-header flex-mid left ${
            activeGrowingTab === 'directReports' ? 'active-tab' : ''
          }`"
          style="width: 120px"
        >
          Direct Reports Only
        </div>
        <div
          @click.prevent="activeGrowingTab = 'overallTeam'"
          :class="`tab-header flex-mid right ${
            activeGrowingTab === 'overallTeam' ? 'active-tab' : ''
          }`"
          style="width: 80px"
        >
          Overall Team
        </div>
      </div> -->
    </div>
    <!-- Quick Insights Summary Cards -->
    <div class="mt-24 talent-summary-grid" v-if="user.boss && !loadingStatus">
      <div class="summary-card-new promotion-card">
        <div class="card-header-new">
          <span class="card-icon-new">🌟</span>
          <span class="card-number-new">{{ talentSummary.promotionReady }}</span>
        </div>
        <div class="card-label-new">{{ $t("weQuarterlyInsights.growing.promotionReady") }}</div>
      </div>
      <div class="summary-card-new development-card">
        <div class="card-header-new">
          <span class="card-icon-new">📈</span>
          <span class="card-number-new">{{ talentSummary.developmentNeeded }}</span>
        </div>
        <div class="card-label-new">{{ $t("weQuarterlyInsights.growing.developmentNeeded") }}</div>
      </div>
      <div class="summary-card-new hidden-gems-card">
        <div class="card-header-new">
          <span class="card-icon-new">💎</span>
          <span class="card-number-new">{{ talentSummary.hiddenGems }}</span>
        </div>
        <div class="card-label-new">{{ $t("weQuarterlyInsights.growing.hiddenGems") }}</div>
      </div>
      <div class="summary-card-new at-risk-card" v-if="talentSummary.atRisk > 0">
        <div class="card-header-new">
          <span class="card-icon-new">⚠️</span>
          <span class="card-number-new">{{ talentSummary.atRisk }}</span>
        </div>
        <div class="card-label-new">{{ $t("weQuarterlyInsights.growing.atRisk") }}</div>
      </div>
    </div>

    <!-- Loading State -->
    <div class="mt-24" v-if="loadingStatus">
      <div class="text-skeleton" style="width: 200px; height: 24px; margin-bottom: 12px">&nbsp;</div>
      <div class="text-skeleton" style="width: 100%; height: 120px">&nbsp;</div>
    </div>

    <!-- Promotion Track Section -->
    <div v-if="user.boss && promotionTrack.length > 0 && !loadingStatus" class="talent-section mt-36">
      <div class="section-header promotion-header">
        <div class="flex-center">
          <div class="header-icon">🌟</div>
          <div class="header-title">{{ $t("weQuarterlyInsights.growing.promotionTrack") }}</div>
          <div class="header-count">({{ promotionTrack.length }})</div>
        </div>
      </div>
      <div class="section-description">
        {{ $t("weQuarterlyInsights.growing.promotionTrackDesc") }}
      </div>
      <div class="talent-cards">
        <div
          v-for="(employee, index) in promotionTrack.slice(0, showAllPromotion ? promotionTrack.length : 3)"
          :key="'promotion-' + employee.email"
          class="talent-card promotion-track-card"
        >
          <div class="card-top flex-center">
            <div v-if="employee.image" class="employee-avatar">
              <img v-lazy="employee.image" :key="employee.image" />
            </div>
            <div v-else class="employee-avatar-placeholder flex-mid">
              {{ $utils("acronymName", { firstName: employee.firstname, lastName: employee.lastname }) }}
            </div>
            <div class="employee-info">
              <div class="employee-name">{{ employee.name }}</div>
              <div class="employee-role">
                <span class="talent-badge promotion-talent">{{ renameTalent(employee.talent) }}</span>
                <span class="network-badge">{{ employee.network_type }}</span>
              </div>
            </div>
            <div class="ml-auto employee-score">
              <div class="score-label">{{ $t("weQuarterlyInsights.growing.Impact_Rating") }}</div>
              <div class="score-value promotion-score">
                {{ employee.impact_rating }}
                <span v-if="parseFloat(employee.impact_rating_change) > 0" class="score-trend up">
                  ↑ {{ employee.impact_rating_change }}
                </span>
                <span v-else-if="parseFloat(employee.impact_rating_change) < 0" class="score-trend down">
                  ↓ {{ Math.abs(employee.impact_rating_change) }}
                </span>
              </div>
            </div>
          </div>
          <div class="card-bottom">
            <div class="achievements-row">
              <div class="achievement-label">{{ $t("weQuarterlyInsights.growing.Achievements") }}:</div>
              <div class="flex-center">
                <div class="achievement-item" v-if="employee.engagedType">
                  <img v-if="employee.engagedType == 'highlyEngaged'" :src="$utils('icons', 'Engagement_Highly_Engaged_32')" title="Highly Engaged" />
                  <img v-else-if="employee.engagedType == 'moderatelyEngaged'" :src="$utils('icons', 'Engagement_Moderately_Engaged_32')" title="Engaged" />
                </div>
                <div class="achievement-item" v-if="employee.medalCount > 0">
                  <span class="badge-count">{{ employee.medalCount }}</span>
                  <img :src="$utils('icons', 'Medals_32')" />
                </div>
                <div class="achievement-item" v-if="employee.truly > 0">
                  <span class="badge-count">{{ employee.truly }}</span>
                  <img :src="$utils('icons', 'Outstanding_32')" />
                </div>
                <div class="achievement-item" v-if="employee.star > 0">
                  <span class="badge-count">{{ employee.star }}</span>
                  <img :src="$utils('icons', 'Super_Star_32')" />
                </div>
              </div>
            </div>
            <div class="recommendation promotion-recommendation">
              💡 {{ $t("weQuarterlyInsights.growing.promotionRecommendation") }}
            </div>
          </div>
        </div>
      </div>
      <div class="show-more-container" v-if="promotionTrack.length > 3">
        <span class="show-more-text" @click="showAllPromotion = !showAllPromotion">
          {{ showAllPromotion ? $t("weQuarterlyInsights.growing.showLess") : $t("weQuarterlyInsights.growing.showMore") + ' (' + (promotionTrack.length - 3) + ')' }}
        </span>
      </div>
    </div>

    <!-- Development Track Section -->
    <div v-if="user.boss && developmentTrack.length > 0 && !loadingStatus" class="talent-section mt-36">
      <div class="section-header development-header">
        <div class="flex-center">
          <div class="header-icon">📈</div>
          <div class="header-title">{{ $t("weQuarterlyInsights.growing.developmentTrack") }}</div>
          <div class="header-count">({{ developmentTrack.length }})</div>
        </div>
      </div>
      <div class="section-description">
        {{ $t("weQuarterlyInsights.growing.developmentTrackDesc") }}
      </div>
      <div class="talent-cards">
        <div
          v-for="employee in developmentTrack.slice(0, showAllDevelopment ? developmentTrack.length : 3)"
          :key="'development-' + employee.email"
          class="talent-card development-track-card"
        >
          <div class="card-top flex-center">
            <div v-if="employee.image" class="employee-avatar">
              <img v-lazy="employee.image" :key="employee.image" />
            </div>
            <div v-else class="employee-avatar-placeholder flex-mid">
              {{ $utils("acronymName", { firstName: employee.firstname, lastName: employee.lastname }) }}
            </div>
            <div class="employee-info">
              <div class="employee-name">{{ employee.name }}</div>
              <div class="employee-role">
                <span class="talent-badge development-talent">{{ renameTalent(employee.talent) }}</span>
                <span class="network-badge">{{ employee.network_type }}</span>
              </div>
            </div>
            <div class="ml-auto employee-score">
              <div class="score-label">{{ $t("weQuarterlyInsights.growing.Impact_Rating") }}</div>
              <div class="score-value development-score">
                {{ employee.impact_rating }}
                <span v-if="parseFloat(employee.impact_rating_change) < 0" class="score-trend down">
                  ↓ {{ Math.abs(employee.impact_rating_change) }}
                </span>
              </div>
            </div>
          </div>
          <div class="card-bottom">
            <div class="warning-row" v-if="employee.engagedType === 'underEngaged' || employee.engagedType === 'inActive'">
              <span class="warning-icon">⚠️</span>
              <span class="warning-text">{{ $t("weQuarterlyInsights.growing.engagementConcern") }}: {{ employee.engagedType === 'inActive' ? $t("weQuarterlyInsights.growing.inactive") : $t("weQuarterlyInsights.growing.underEngaged") }}</span>
            </div>
            <div class="recommendation development-recommendation">
              💡 {{ $t("weQuarterlyInsights.growing.developmentRecommendation") }}
            </div>
          </div>
        </div>
      </div>
      <div class="show-more-container" v-if="developmentTrack.length > 3">
        <span class="show-more-text" @click="showAllDevelopment = !showAllDevelopment">
          {{ showAllDevelopment ? $t("weQuarterlyInsights.growing.showLess") : $t("weQuarterlyInsights.growing.showMore") + ' (' + (developmentTrack.length - 3) + ')' }}
        </span>
      </div>
    </div>

    <!-- Hidden Gems Section -->
    <div v-if="user.boss && hiddenGems.length > 0 && !loadingStatus" class="talent-section mt-36">
      <div class="section-header hidden-gems-header">
        <div class="flex-center">
          <div class="header-icon">💎</div>
          <div class="header-title">{{ $t("weQuarterlyInsights.growing.hiddenGemsTrack") }}</div>
          <div class="header-count">({{ hiddenGems.length }})</div>
        </div>
      </div>
      <div class="section-description">
        {{ $t("weQuarterlyInsights.growing.hiddenGemsDesc") }}
      </div>
      <div class="talent-cards">
        <div
          v-for="employee in hiddenGems.slice(0, showAllHidden ? hiddenGems.length : 3)"
          :key="'hidden-' + employee.email"
          class="talent-card hidden-gems-track-card"
        >
          <div class="card-top flex-center">
            <div v-if="employee.image" class="employee-avatar">
              <img v-lazy="employee.image" :key="employee.image" />
            </div>
            <div v-else class="employee-avatar-placeholder flex-mid">
              {{ $utils("acronymName", { firstName: employee.firstname, lastName: employee.lastname }) }}
            </div>
            <div class="employee-info">
              <div class="employee-name">{{ employee.name }}</div>
              <div class="employee-role">
                <span class="talent-badge hidden-talent">{{ renameTalent(employee.talent) }}</span>
                <span class="network-badge warning">{{ employee.network_type }}</span>
              </div>
            </div>
            <div class="ml-auto employee-score">
              <div class="score-label">{{ $t("weQuarterlyInsights.growing.Impact_Rating") }}</div>
              <div class="score-value hidden-score">
                {{ employee.impact_rating }}
                <span v-if="parseFloat(employee.impact_rating_change) > 0" class="score-trend up">
                  ↑ {{ employee.impact_rating_change }}
                </span>
              </div>
            </div>
          </div>
          <div class="card-bottom">
            <div class="recommendation hidden-recommendation">
              💡 {{ $t("weQuarterlyInsights.growing.hiddenGemsRecommendation") }}
            </div>
          </div>
        </div>
      </div>
      <div class="show-more-container" v-if="hiddenGems.length > 3">
        <span class="show-more-text" @click="showAllHidden = !showAllHidden">
          {{ showAllHidden ? $t("weQuarterlyInsights.growing.showLess") : $t("weQuarterlyInsights.growing.showMore") + ' (' + (hiddenGems.length - 3) + ')' }}
        </span>
      </div>
    </div>

    <!-- At-Risk High Performers Section -->
    <div v-if="user.boss && atRiskHighPerformers.length > 0 && !loadingStatus" class="talent-section mt-36">
      <div class="section-header at-risk-header">
        <div class="flex-center">
          <div class="header-icon">⚠️</div>
          <div class="header-title">{{ $t("weQuarterlyInsights.growing.atRiskTrack") }}</div>
          <div class="header-count">({{ atRiskHighPerformers.length }})</div>
        </div>
      </div>
      <div class="section-description">
        {{ $t("weQuarterlyInsights.growing.atRiskDesc") }}
      </div>
      <div class="talent-cards">
        <div
          v-for="employee in atRiskHighPerformers"
          :key="'atrisk-' + employee.email"
          class="talent-card at-risk-track-card"
        >
          <div class="card-top flex-center">
            <div v-if="employee.image" class="employee-avatar">
              <img v-lazy="employee.image" :key="employee.image" />
            </div>
            <div v-else class="employee-avatar-placeholder flex-mid">
              {{ $utils("acronymName", { firstName: employee.firstname, lastName: employee.lastname }) }}
            </div>
            <div class="employee-info">
              <div class="employee-name">{{ employee.name }}</div>
              <div class="employee-role">
                <span class="talent-badge at-risk-talent">{{ renameTalent(employee.talent) }}</span>
                <span class="network-badge">{{ employee.network_type }}</span>
              </div>
            </div>
            <div class="ml-auto employee-score">
              <div class="score-label">{{ $t("weQuarterlyInsights.growing.Impact_Rating") }}</div>
              <div class="score-value at-risk-score">
                {{ employee.impact_rating }}
                <span class="score-trend down">
                  ↓ {{ Math.abs(employee.impact_rating_change) }}
                </span>
              </div>
            </div>
          </div>
          <div class="card-bottom">
            <div class="warning-row">
              <span class="warning-icon">⚠️</span>
              <span class="warning-text">{{ $t("weQuarterlyInsights.growing.retentionRisk") }}</span>
            </div>
            <div class="recommendation at-risk-recommendation">
              💡 {{ $t("weQuarterlyInsights.growing.atRiskRecommendation") }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-36">
      <div v-if="loadingStatus" class="mt-36">
        <div class="profile-card" style="background-color: #f7f4fc">
          <div class="profile top flex-center">
            <div class="image-skeleton image-profile-42 flex-mid mr-16"></div>
            <div class="text-skeleton" style="min-width: 110px; width: 40px">
              &nbsp;
            </div>
            <div class="ml-auto flex-center">
              <div class="fc-000000 fs-13 mr-12">
                {{ $t("weQuarterlyInsights.growing.s_starPerformer") }}
              </div>
              <div class="fs-30" style="color: #fbb040">
                <i class="el-icon-star-on"></i>
              </div>
              <div class="fc-000000 pb-4 mr-4">x</div>
              <div class="fs-20 fw-700 text-skeleton" style="width: 20px">
                &nbsp;
              </div>
            </div>
          </div>
          <div class="font-lato profile bottom flex-center">&nbsp;</div>
        </div>
      </div>
      <div v-else class="profile-card user-talent-card">
        <div class="profile top flex-center">
          <div :class="`avatar-with-health health-${userCardData.healthIndicator || 'green'}`">
            <div v-if="user.image">
              <img
                v-lazy="user.image"
                :key="user.image"
                class="image-skeleton image-profile-42 flex-mid mr-16"
              />
            </div>
            <div v-else class="image image-profile-42 flex-mid mr-16">
              <div
                class="flex-mid text-in-image text-in-image-42"
                style="width: 42px"
              >
                {{
                  $utils("acronymName", {
                    firstName: user.firstname,
                    lastName: user.lastname,
                  })
                }}
              </div>
            </div>
          </div>
          <div
            class="fs-16 fw-700 fc-000000 font-lato"
            style="min-width: 130px"
          >
            {{ user.name }}
          </div>
          <!-- <div v-if="user.boss" class="flex-center">
            <div v-if="userCardData.talentChanged" class="flex-center">
              <span class="talent old">{{ userCardData.oldTalent }}</span>
              <div class="fs-22 mx-10" style="color: #6d27bf">
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </div>
            <span v-if="userCardData.talent" class="talent now">{{
              userCardData.talent
            }}</span>
          </div> -->
          <!-- Removed duplicate impact rating display for cleaner design -->
        </div>
        <div class="talent-dashboard">
          <div class="talent-grid" v-if="userCardData && userCardData.impact_rating">
            <!-- Performance Status -->
            <div class="performance-status">
              <div class="status-header">
                <div class="status-indicator" :class="getStatusClass(userCardData)"></div>
                <div class="status-content">
                  <div class="status-title">{{ getStatusTitle(userCardData) }}</div>
                  <div class="status-subtitle">Performance Track</div>
                </div>
              </div>
              
              <div class="talent-classification">
                <div class="talent-label">Classification</div>
                <div class="talent-badge" :class="getTalentBadgeClass(userCardData.talent)">
                  <div class="talent-icon">{{ getTalentIcon(userCardData.talent) }}</div>
                  <div class="talent-name">{{ renameTalent(userCardData.talent) }}</div>
                </div>
              </div>
            </div>

            <!-- Impact Score -->
            <div class="impact-score-section">
              <el-tooltip effect="light" placement="top" popper-class="custom-tooltip">
                <div slot="content" class="tooltip-content">
                  <div class="tooltip-header">
                    <div class="tooltip-title">Impact Rating</div>
                    <div class="tooltip-score">{{ userCardData.impact_rating }}</div>
                  </div>
                  <div class="tooltip-description">
                    A comprehensive score reflecting performance, engagement, and contribution to team success.
                  </div>
                  <div class="tooltip-breakdown">
                    <div class="breakdown-item">
                      <span class="breakdown-label">Talent Assessment</span>
                      <span class="breakdown-value">{{ toolTipStatus(userCardData.talentClass) }}</span>
                    </div>
                    <div class="breakdown-item">
                      <span class="breakdown-label">Network Influence</span>
                      <span class="breakdown-value">{{ toolTipStatus(userCardData.networkClass) }}</span>
                    </div>
                    <div class="breakdown-item">
                      <span class="breakdown-label">Engagement Level</span>
                      <span class="breakdown-value">{{ toolTipStatus(userCardData.engagementClass) }}</span>
                    </div>
                  </div>
                </div>
                <div class="impact-display">
                  <div class="impact-score" :class="getScoreClass(userCardData.impact_rating)">
                    {{ userCardData.impact_rating }}
                  </div>
                  <div class="impact-label">Impact Rating</div>
                  <div v-if="userCardData.impact_rating_change" class="impact-trend" :class="getTrendClass(userCardData.impact_rating_change)">
                    <svg class="trend-icon" viewBox="0 0 24 24" width="16" height="16">
                      <path v-if="parseFloat(userCardData.impact_rating_change) > 0" d="M7 14l5-5 5 5z" fill="currentColor"/>
                      <path v-else d="M7 10l5 5 5-5z" fill="currentColor"/>
                    </svg>
                    <span class="trend-value">{{ Math.abs(userCardData.impact_rating_change) }}</span>
                  </div>
                </div>
              </el-tooltip>
            </div>

            <!-- Recognition & Values -->
            <div class="recognition-section">
              <div class="peer-recognition">
                <div class="recognition-header">
                  <div class="recognition-title">Peer Recognition</div>
                  <div class="recognition-level">Level {{ userCardData.peerRecognitionLevel || 0 }}</div>
                </div>
                <div class="recognition-bars">
                  <div
                    v-for="i in 4"
                    :key="'peer-' + i"
                    class="recognition-bar"
                    :class="{ 'active': i <= (userCardData.peerRecognitionLevel || 0) }"
                    :style="{ animationDelay: (i * 100) + 'ms' }"
                  ></div>
                </div>
              </div>
              
              <div class="values-score" v-if="userCardData.valuesScore">
                <div class="values-display">
                  <div class="values-number">{{ userCardData.valuesScore }}</div>
                  <div class="values-icon">
                    <svg viewBox="0 0 24 24" width="20" height="20">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" fill="currentColor"/>
                    </svg>
                  </div>
                </div>
                <div class="values-label">Values Alignment</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="user.boss"
      class="fs-16 fw-700 fc-000000 font-lato opa-08 mt-34 mb-24"
    >
      {{ $t("weQuarterlyInsights.growing.yourDirectReports") }}
    </div>
    <div v-if="loadingStatus">
      <div class="profile-card">
        <div class="profile top flex-center">
          <div class="image-skeleton image-profile-42 flex-mid mr-16"></div>
          <div class="text-skeleton" style="min-width: 110px; width: 40px">
            &nbsp;
          </div>
          <div class="ml-auto flex-center">
            <div
              class="text-skeleton fc-000000 fs-13 mr-12 mr-40"
              style="width: 140px"
            >
              &nbsp;
            </div>
          </div>
        </div>
        <div class="font-lato profile bottom flex-center">
          <div class="fs-12">&nbsp;</div>
        </div>
      </div>
    </div>
    <div
      v-else-if="user.boss"
      v-for="(user, index) in directReportsCardData"
      :key="'userCard_' + index + user.name"
    >
      <div v-if="index < 3" class="profile-card mt-12">
        <div class="profile top flex-center">
          <div v-if="user.image">
            <img
              v-lazy="user.image"
              :key="user.image"
              class="image-skeleton image-profile-42 flex-mid mr-16"
            />
          </div>
          <div v-else class="image image-profile-42 flex-mid mr-16">
            <div
              class="flex-mid text-in-image text-in-image-42"
              style="width: 42px"
            >
              {{
                $utils("acronymName", {
                  firstName: user.firstname,
                  lastName: user.lastname,
                })
              }}
            </div>
          </div>
          <div
            class="fs-16 fw-700 fc-000000 font-lato"
            style="min-width: 110px"
          >
            {{ user.name }}
          </div>
          <!-- <div class="flex-center">
            <div v-if="user.talentChanged" class="flex-center">
              <span class="talent old">{{ user.oldTalent }}</span>
              <div class="fs-22 mx-10" style="color: #6d27bf">
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </div>
            <span v-if="user.talent" class="talent now">{{ user.talent }}</span>
          </div> -->
          <div class="flex-center fs-12 fw-700 ml-auto">
            <div class="fw-700 fs-12">
              {{ $t("weQuarterlyInsights.growing.Impact_Rating") }}
            </div>
            <!-- 60.2 is now value, 65.1 is old value, 4.9 is how change -->
            <div
              :class="`impact-tag ml-12 flex-mid impact-tag-${
                user.impact_rating < 40
                  ? 'red'
                  : user.impact_rating < 70
                  ? 'yellow'
                  : 'green'
              }`"
            >
              {{ user.impact_rating }}
            </div>
            <div
              v-if="user.impact_rating > user.impact_rating_lastweek"
              class="fc-66BB6A flex-center"
            >
              <img
                :src="$utils('icons', 'arrow_up_green_24dp')"
                alt="icons_arrow_up_green_24dp"
              />
              <div style="margin-left: -4px" class="fc-66BB6A">
                {{ user.impact_rating_change }}
              </div>
            </div>
            <div
              v-else-if="user.impact_rating_lastweek > user.impact_rating"
              class="fc-F44336 flex-center"
            >
              <img
                :src="$utils('icons', 'arrow_down_red_24dp')"
                alt="icons_arrow_down_red_24dp"
              />
              <div style="margin-left: -4px">
                {{ user.impact_rating_change }}
              </div>
            </div>
            <div v-else-if="user.impact_rating == user.impact_rating_lastweek">
              <!-- <img :src="$utils('icons', 'arrow_down_red_24dp')" alt="icons_arrow_down_red_24dp" />
                  <div style="margin-left: -4px">{{ scope.row.impact_compare }}</div> -->
            </div>
          </div>
        </div>
        <div
          class="font-lato profile bottom flex-center fc-000000 fw-700 fs-12"
        >
          <div>Talent Type</div>
          <div
            :class="`talent-tag ml-12 ${talentAndNetworkTagsStyle(
              user.talent
            )}`"
          >
            <span>{{ renameTalent(user.talent) }}</span>
          </div>
          <div class="ml-12">
            {{ $t("weQuarterlyInsights.growing.Network_Type") }}
          </div>
          <div
            :class="`talent-tag ml-12 ${talentAndNetworkTagsStyle(
              user.network_type
            )}`"
          >
            <span>{{ user.network_type }}</span>
          </div>
          <div class="ml-auto">
            {{ $t("weQuarterlyInsights.growing.Achievements") }}
          </div>
          <div class="flex-center ml-12" style="height: 50px">
            <div class="achievements-contariner">
              <img
                v-if="user.engagedType == 'highlyEngaged'"
                :src="$utils('icons', 'Engagement_Highly_Engaged_32')"
                alt="icons_Engagement_Highly_Engaged_32"
                title="Highly Engaged"
              />
              <img
                v-else-if="user.engagedType == 'moderatelyEngaged'"
                :src="$utils('icons', 'Engagement_Moderately_Engaged_32')"
                alt="icons_Engagement_Moderately_Engaged_32"
                title="Engaged"
              />
              <img
                v-else-if="user.engagedType == 'somewhatEngaged'"
                :src="$utils('icons', 'Engagement_Somewhat_Engaged_32')"
                alt="icons_Engagement_Somewhat_Engaged_32"
                title="Somewhat Engaged"
              />
              <img
                v-else-if="user.engagedType == 'underEngaged'"
                :src="$utils('icons', 'Engagement_Under_Engaged_32')"
                alt="icons_Engagement_Under_Engaged_32"
                title="Under Engaged"
              />
              <img
                v-else-if="user.engagedType == 'inActive'"
                :src="$utils('icons', 'Engagement_In-Active_32')"
                alt="icons_Engagement_In-Active_32"
                title="In-Active"
              />
              <div v-else class="engagement-no-data flex-mid">No Data</div>
            </div>
            <div
              :class="`achievements-contariner ${
                user.medalCount < 1 ? 'no-have' : ''
              }`"
            >
              <div v-if="user.medalCount > 0" class="count-icon">
                {{ user.medalCount }}
              </div>
              <img :src="$utils('icons', 'Medals_32')" alt="icons_Medals_32" />
            </div>
            <div
              :class="`achievements-contariner ${
                user.truly == undefined || user.truly == 0 ? 'no-have' : ''
              }`"
            >
              <div v-if="user.truly > 0" class="count-icon">
                {{ user.truly }}
              </div>
              <img
                :src="$utils('icons', 'Outstanding_32')"
                alt="icons_Outstanding_32"
              />
            </div>
            <div
              :class="`achievements-contariner ${
                user.star < 1 ? 'no-have' : ''
              }`"
            >
              <div v-if="user.star > 0" class="count-icon">
                {{ user.star }}
              </div>
              <img
                :src="$utils('icons', 'Super_Star_32')"
                alt="icons_Super_Star_32"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="showMoreDirectReport" class="profile-card mt-12">
        <div class="profile top flex-center">
          <div v-if="user.image">
            <img
              v-lazy="user.image"
              :key="user.image"
              class="image-skeleton image-profile-42 flex-mid mr-16"
            />
          </div>
          <div v-else class="image image-profile-42 flex-mid mr-16">
            <div
              class="flex-mid text-in-image text-in-image-42"
              style="width: 42px"
            >
              {{
                $utils("acronymName", {
                  firstName: user.firstname,
                  lastName: user.lastname,
                })
              }}
            </div>
          </div>
          <div
            class="fs-16 fw-700 fc-000000 font-lato"
            style="min-width: 110px"
          >
            {{ user.name }}
          </div>
          <!-- <div class="flex-center">
            <div v-if="user.talentChanged" class="flex-center">
              <span class="talent old">{{ user.oldTalent }}</span>
              <div class="fs-22 mx-10" style="color: #6d27bf">
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </div>
            <span v-if="user.talent" class="talent now">{{ user.talent }}</span>
          </div> -->
          <div class="flex-center fs-12 fw-700 ml-auto">
            <div class="fw-700 fs-12">
              {{ $t("weQuarterlyInsights.growing.Impact_Rating") }}
            </div>
            <!-- 60.2 is now value, 65.1 is old value, 4.9 is how change -->
            <div
              :class="`impact-tag ml-12 flex-mid impact-tag-${
                user.impact_rating < 40
                  ? 'red'
                  : user.impact_rating < 70
                  ? 'yellow'
                  : 'green'
              }`"
            >
              {{ user.impact_rating }}
            </div>
            <div
              v-if="user.impact_rating > user.impact_rating_lastweek"
              class="fc-66BB6A flex-center"
            >
              <img
                :src="$utils('icons', 'arrow_up_green_24dp')"
                alt="icons_arrow_up_green_24dp"
              />
              <div style="margin-left: -4px" class="fc-66BB6A">
                {{ user.impact_rating_change }}
              </div>
            </div>
            <div
              v-else-if="user.impact_rating_lastweek > user.impact_rating"
              class="fc-F44336 flex-center"
            >
              <img
                :src="$utils('icons', 'arrow_down_red_24dp')"
                alt="icons_arrow_down_red_24dp"
              />
              <div style="margin-left: -4px">
                {{ user.impact_rating_change }}
              </div>
            </div>
            <div v-else-if="user.impact_rating == user.impact_rating_lastweek">
              <!-- <img :src="$utils('icons', 'arrow_down_red_24dp')" alt="icons_arrow_down_red_24dp" />
                  <div style="margin-left: -4px">{{ scope.row.impact_compare }}</div> -->
            </div>
          </div>
        </div>
        <div
          class="font-lato profile bottom flex-center fc-000000 fw-700 fs-12"
        >
          <div>Talent Type</div>
          <div
            :class="`talent-tag ml-12 ${talentAndNetworkTagsStyle(
              user.talent
            )}`"
          >
            <span>{{ renameTalent(user.talent) }}</span>
          </div>
          <div class="ml-12">
            {{ $t("weQuarterlyInsights.growing.Network_Type") }}
          </div>
          <div
            :class="`talent-tag ml-12 ${talentAndNetworkTagsStyle(
              user.network_type
            )}`"
          >
            <span>{{ user.network_type }}</span>
          </div>
          <div class="ml-auto">
            {{ $t("weQuarterlyInsights.growing.Achievements") }}
          </div>
          <div class="flex-center ml-12" style="height: 50px">
            <div class="achievements-contariner">
              <img
                v-if="user.engagedType == 'highlyEngaged'"
                :src="$utils('icons', 'Engagement_Highly_Engaged_32')"
                alt="icons_Engagement_Highly_Engaged_32"
                title="Highly Engaged"
              />
              <img
                v-else-if="user.engagedType == 'moderatelyEngaged'"
                :src="$utils('icons', 'Engagement_Moderately_Engaged_32')"
                alt="icons_Engagement_Moderately_Engaged_32"
                title="Engaged"
              />
              <img
                v-else-if="user.engagedType == 'somewhatEngaged'"
                :src="$utils('icons', 'Engagement_Somewhat_Engaged_32')"
                alt="icons_Engagement_Somewhat_Engaged_32"
                title="Somewhat Engaged"
              />
              <img
                v-else-if="user.engagedType == 'underEngaged'"
                :src="$utils('icons', 'Engagement_Under_Engaged_32')"
                alt="icons_Engagement_Under_Engaged_32"
                title="Under Engaged"
              />
              <img
                v-else-if="user.engagedType == 'inActive'"
                :src="$utils('icons', 'Engagement_In-Active_32')"
                alt="icons_Engagement_In-Active_32"
                title="In-Active"
              />
              <div v-else class="engagement-no-data flex-mid">No Data</div>
            </div>
            <div
              :class="`achievements-contariner ${
                user.medalCount < 1 ? 'no-have' : ''
              }`"
            >
              <div v-if="user.medalCount > 0" class="count-icon">
                {{ user.medalCount }}
              </div>
              <img :src="$utils('icons', 'Medals_32')" alt="icons_Medals_32" />
            </div>
            <div
              :class="`achievements-contariner ${
                user.truly == undefined || user.truly == 0 ? 'no-have' : ''
              }`"
            >
              <div v-if="user.truly > 0" class="count-icon">
                {{ user.truly }}
              </div>
              <img
                :src="$utils('icons', 'Outstanding_32')"
                alt="icons_Outstanding_32"
              />
            </div>
            <div
              :class="`achievements-contariner ${
                user.star < 1 ? 'no-have' : ''
              }`"
            >
              <div v-if="user.star > 0" class="count-icon">
                {{ user.star }}
              </div>
              <img
                :src="$utils('icons', 'Super_Star_32')"
                alt="icons_Super_Star_32"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mt-32 flex-mid"
      v-if="
        !showMoreDirectReport && user.boss && directReportsCardData.length > 3
      "
    >
      <span
        class="show-more-text"
        @click="showMoreDirectReport = !showMoreDirectReport"
      >
        {{ $t("weQuarterlyInsights.growing.showMore") }} ({{
          directReportsCardData.length - 3
        }})
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      id: String,
      name: String,
      firstname: String,
      lastname: String,
      month: String,
      year: String,
      image: String,
    },
  },
  data() {
    return {
      activeGrowingTab: "directReports",
      showMoreDirectReport: false,
      showAllPromotion: false,
      showAllDevelopment: false,
      showAllHidden: false,
    };
  },
  computed: {
    growingData() {
      return this.$store.getters["quarterlyEngaged/growingData"];
    },
    directReportsCardData() {
      return this.$store.getters["quarterlyEngaged/directReportsCardData"];
    },
    userCardData() {
      const storeData = this.$store.getters["quarterlyEngaged/userCardData"];

      /*
       * PLACEHOLDER DATA TOGGLE
       * =======================
       * Set USE_PLACEHOLDER = false to use real API data
       * Set USE_PLACEHOLDER = true to use dummy data for design preview
       */
      const USE_PLACEHOLDER = true;

      if (USE_PLACEHOLDER && (!storeData || !storeData.impact_rating)) {
        return {
          name: this.user.name || 'Tareef J',
          firstname: this.user.firstname || 'Tareef',
          lastname: this.user.lastname || 'Jafferi',
          image: this.user.image || '',
          email: this.user.email || 'tareef@happily.ai',
          talent: 'Distinguished Talent',
          network_type: 'High Network',
          impact_rating: '73.9',
          impact_rating_change: '0.6',
          engagedType: 'highlyEngaged',
          medalCount: 12,
          truly: 3,
          star: 2,
          goalStatus: 'Exceeded',
          managerRecognitionLevel: 3,
          peerRecognitionLevel: 4,
          healthIndicator: 'green',
          skillsScore: '3.7',
          valuesScore: '7.4',
          cultureAddLevel: 'Consistently',
          talentClass: 'd',
          networkClass: 'c',
          engagementClass: 'd'
        };
      }

      return storeData;
    },
    loadingStatus() {
      return this.$store.getters["quarterlyEngaged/loadingStatus"];
    },
    talentSummary() {
      const storeSummary = this.$store.getters["quarterlyEngaged/talentSummary"];

      // Placeholder summary if no data
      if (!storeSummary || storeSummary.total === 0) {
        return {
          promotionReady: 2,
          developmentNeeded: 1,
          hiddenGems: 1,
          atRisk: 0,
          total: 8
        };
      }

      return storeSummary;
    },
    promotionTrack() {
      return this.$store.getters["quarterlyEngaged/promotionTrack"];
    },
    developmentTrack() {
      return this.$store.getters["quarterlyEngaged/developmentTrack"];
    },
    hiddenGems() {
      return this.$store.getters["quarterlyEngaged/hiddenGems"];
    },
    atRiskHighPerformers() {
      return this.$store.getters["quarterlyEngaged/atRiskHighPerformers"];
    },
  },
  created() {
    //this.$store.dispatch("quarterlyInsignhts/getUserTeam", this.user);
  },
  mounted() {},
  methods: {
    getUserTrack(employee) {
      const impactRating = parseFloat(employee.impact_rating) || 0;
      const impactChange = parseFloat(employee.impact_rating_change) || 0;

      // Promotion track
      const isHighPerformer = impactRating >= 70;
      const isTopTalent = [
        'Superstar', 'High Performer', 'Distinguished Talent',
        'Respected Expert', 'Solid Performer'
      ].includes(employee.talent);
      const isHighlyEngaged = employee.engagedType === 'highlyEngaged' || employee.engagedType === 'moderatelyEngaged';

      if (isHighPerformer && (isTopTalent || isHighlyEngaged)) {
        return 'promotion';
      }

      // Hidden gems
      const isGoodPerformer = impactRating >= 60 && impactRating < 70;
      const isLowVisibility = ['Low Network', 'Medium Network', 'Medium Inner', 'Medium Outer'].includes(employee.network_type);
      const isHiddenTalent = [
        'Hidden Gem', 'Unsung Talent', 'Emerging Talent',
        'Untapped Potential', 'High Potential'
      ].includes(employee.talent);

      if ((isGoodPerformer && isLowVisibility) || isHiddenTalent) {
        return 'hidden';
      }

      // At risk
      const isSignificantDecline = impactChange < -8;
      const wasHighlyEngaged = employee.engagedType === 'somewhatEngaged' || employee.engagedType === 'underEngaged';

      if (impactRating >= 60 && isTopTalent && (isSignificantDecline || wasHighlyEngaged)) {
        return 'at-risk';
      }

      // Development
      const isLowPerformer = impactRating < 40;
      const isDeclining = impactChange < -5;
      const isDisengaged = employee.engagedType === 'underEngaged' || employee.engagedType === 'inActive';

      if (isLowPerformer || (isDeclining && impactRating < 60) || isDisengaged) {
        return 'development';
      }

      return 'maintain';
    },
    getStatusClass(employee) {
      const track = this.getUserTrack(employee);
      return `status-${track}`;
    },
    getStatusTitle(employee) {
      const track = this.getUserTrack(employee);
      switch (track) {
        case 'promotion': return 'Promotion Ready';
        case 'hidden': return 'Hidden Gem';
        case 'development': return 'Needs Development';
        case 'at-risk': return 'At Risk';
        default: return 'On Track';
      }
    },
    getTalentIcon(talent) {
      const talentMap = {
        'Superstar': '⭐',
        'High Performer': '🚀',
        'Distinguished Talent': '💎',
        'Respected Expert': '🎯',
        'Solid Performer': '✨',
        'Hidden Gem': '💎',
        'Unsung Talent': '🌟',
        'Emerging Talent': '🌱',
        'Untapped Potential': '💫',
        'High Potential': '🔥',
        'Starter': '🌱'
      };
      return talentMap[talent] || '⚡';
    },
    getTalentBadgeClass(talent) {
      if (['Superstar', 'High Performer', 'Distinguished Talent', 'Respected Expert'].includes(talent)) {
        return 'talent-excellent';
      } else if (['Solid Performer', 'Hidden Gem', 'Unsung Talent', 'Emerging Talent'].includes(talent)) {
        return 'talent-good';
      } else {
        return 'talent-developing';
      }
    },
    getScoreClass(score) {
      const numScore = parseFloat(score);
      if (numScore >= 70) return 'score-excellent';
      if (numScore >= 40) return 'score-good';
      return 'score-needs-improvement';
    },
    getTrendClass(change) {
      const numChange = parseFloat(change);
      return numChange > 0 ? 'trend-up' : 'trend-down';
    },
    renameTalent(text) {
      console.log(text)
      if (text === "Latent Potential") {
        return "Starter";
      } else if (text == "Hidden Talent") {
        return "Hidden Gem";
      }
      return text;
    },
    showVideo() {
      this.$emit("dialogValue", { value: true, text: "section-5" });
    },
    growingCardStyle(value) {
      let style = "growing-card flex-center ";
      if (value.highlight) {
        style += "highlight ";
      } else if (value.grayBlock) {
        style += "gray-block ";
      }
      style += value.name;
      return style;
    },
    talentAndNetworkTagsStyle(value) {
      if (value == "Low Network" || value == "Latent Potential") {
        return "tag-red";
      } else if (
        value == "Medium Inner" ||
        value == "Medium Outer" ||
        value == "Medium Network" ||
        value == "Up-and-coming" ||
        value == "Contributor" ||
        value == "Community Pillar" ||
        value == "Rising Star" ||
        value == "Crowd Favorite"
      ) {
        return "tag-half-red";
      } else if (
        value == "High Outer" ||
        value == "High Inner" ||
        value == "High Potential" ||
        value == "Valued Contributor" ||
        value == "Untapped Potential" ||
        value == "Engaged Contributor" ||
        value == "Emerging Talent" ||
        value == "Unsung Talent" ||
        value == "Hidden Gem"
      ) {
        return "tag-orange";
      } else if (
        value == "Super Outer" ||
        value == "High Network" ||
        value == "Super Inner" ||
        value == "Activated" ||
        value == "Key Player" ||
        value == "Core Player" ||
        value == "Solid Performer" ||
        value == "High Performer"
      ) {
        return "tag-half-green";
      } else if (
        value == "Super Outer" ||
        value == "Superstar" ||
        value == "High Performer" ||
        value == "Respected Expert"||
        value == "Distinguished Talent"
      ) {
        return "tag-green";
      }
      return "tag-green";
    },
    toolTipStatus(value) {
      switch (value) {
        case "a":
          return this.$t("weQuarterlyInsights.growing.LOW");
        case "b":
          return this.$t("weQuarterlyInsights.growing.OKAY");
        case "c":
          return this.$t("weQuarterlyInsights.growing.GREAT");
        case "d":
          return this.$t("weQuarterlyInsights.growing.EXCELLENT");
      }
    },
    toolTipClass(value) {
      switch (value) {
        case "a":
          return "color: #F22F3C;";
        case "b":
          return "color: #C69312;";
        case "c":
          return "color: #27BC6C;";
        case "d":
          return "color: #27BC6C;";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Talent Summary Cards - matching existing report style
.talent-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
  margin-bottom: 16px;

  .summary-card-new {
    background: #fcfcfc;
    border-radius: 11px;
    padding: 16px;
    border: 1px solid #00000033;
    box-shadow: 0 3px 6px #00000029;
    transition: transform 0.15s, box-shadow 0.15s;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 8px #0000003d;
    }

    .card-header-new {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 6px;

      .card-icon-new {
        font-size: 24px;
      }

      .card-number-new {
        font-size: 32px;
        font-weight: 900;
        font-family: 'Lato', sans-serif;
        line-height: 1;
      }
    }

    .card-label-new {
      font-size: 11px;
      font-weight: 700;
      opacity: 0.7;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: #15253c;
    }

    &.promotion-card {
      border-left: 4px solid #66bb6a;
      .card-number-new { color: #66bb6a; }
    }

    &.development-card {
      border-left: 4px solid #f44336;
      .card-number-new { color: #f44336; }
    }

    &.hidden-gems-card {
      border-left: 4px solid #fbc02d;
      .card-number-new { color: #fbc02d; }
    }

    &.at-risk-card {
      border-left: 4px solid #ef6c00;
      .card-number-new { color: #ef6c00; }
    }
  }
}

// World-class talent card design
.user-talent-card {
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 
    0 1px 3px rgba(0, 0, 0, 0.04),
    0 8px 24px rgba(0, 0, 0, 0.06),
    0 0 0 1px rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
    z-index: 1;
  }

  &:hover {
    transform: translateY(-4px) scale(1.01);
    box-shadow: 
      0 4px 12px rgba(0, 0, 0, 0.08),
      0 20px 40px rgba(0, 0, 0, 0.12),
      0 0 0 1px rgba(255, 255, 255, 0.2);
  }

  .profile.top {
    padding: 28px 32px 20px;
    background: linear-gradient(135deg, #fafbfc 0%, #ffffff 100%);
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 32px;
      right: 32px;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.06), transparent);
    }

    .avatar-with-health {
      position: relative;
      border-radius: 50%;
      padding: 3px;
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      box-shadow: 
        0 4px 12px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.6);
      transition: all 0.3s ease;

      &.health-green {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        box-shadow: 
          0 4px 12px rgba(16, 185, 129, 0.3),
          inset 0 1px 0 rgba(255, 255, 255, 0.3);
      }

      &.health-yellow {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        box-shadow: 
          0 4px 12px rgba(245, 158, 11, 0.3),
          inset 0 1px 0 rgba(255, 255, 255, 0.3);
      }

      &.health-red {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        box-shadow: 
          0 4px 12px rgba(239, 68, 68, 0.3),
          inset 0 1px 0 rgba(255, 255, 255, 0.3);
      }

      .image-profile-42, .image {
        border: 2px solid #ffffff;
        border-radius: 50%;
        box-shadow: 
          0 2px 8px rgba(0, 0, 0, 0.1),
          inset 0 1px 0 rgba(255, 255, 255, 0.2);
      }
    }
  }

  .talent-dashboard {
    padding: 32px;
    background: #ffffff;
  }

  .talent-grid {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 48px;
    align-items: start;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 33.33%;
      top: 0;
      bottom: 0;
      width: 1px;
      background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.06), transparent);
    }

    &::after {
      content: '';
      position: absolute;
      right: 33.33%;
      top: 0;
      bottom: 0;
      width: 1px;
      background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.06), transparent);
    }
  }

  // Performance Status Section
  .performance-status {
    .status-header {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 24px;

      .status-indicator {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        position: relative;
        flex-shrink: 0;

        &::before {
          content: '';
          position: absolute;
          inset: -4px;
          border-radius: 50%;
          background: inherit;
          opacity: 0.2;
          animation: pulse 2s infinite;
        }

        &.status-promotion {
          background: linear-gradient(135deg, #10b981, #059669);
          box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);
        }

        &.status-hidden {
          background: linear-gradient(135deg, #f59e0b, #d97706);
          box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.1);
        }

        &.status-development {
          background: linear-gradient(135deg, #ef4444, #dc2626);
          box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
        }

        &.status-at-risk {
          background: linear-gradient(135deg, #f97316, #ea580c);
          box-shadow: 0 0 0 4px rgba(249, 115, 22, 0.1);
        }

        &.status-maintain {
          background: linear-gradient(135deg, #6b7280, #4b5563);
          box-shadow: 0 0 0 4px rgba(107, 114, 128, 0.1);
        }
      }

      .status-content {
        .status-title {
          font-size: 16px;
          font-weight: 700;
          color: #111827;
          margin-bottom: 2px;
          line-height: 1.2;
        }

        .status-subtitle {
          font-size: 12px;
          font-weight: 500;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.6px;
        }
      }
    }

    .talent-classification {
      .talent-label {
        font-size: 11px;
        font-weight: 600;
        color: #6b7280;
        text-transform: uppercase;
        letter-spacing: 0.8px;
        margin-bottom: 12px;
      }

      .talent-badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 8px 16px;
        border-radius: 12px;
        font-size: 13px;
        font-weight: 600;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          transition: left 0.5s;
        }

        &:hover::before {
          left: 100%;
        }

        .talent-icon {
          font-size: 16px;
          line-height: 1;
        }

        .talent-name {
          font-weight: 600;
          letter-spacing: 0.3px;
        }
      }
    }
  }

  // Impact Score Section
  .impact-score-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 24px;

    .impact-display {
      text-align: center;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      padding: 24px;
      border-radius: 20px;
      position: relative;
      background: linear-gradient(135deg, #fafbfc 0%, #f8f9fa 100%);
      border: 1px solid rgba(0, 0, 0, 0.04);
      box-shadow: 
        0 1px 3px rgba(0, 0, 0, 0.04),
        inset 0 1px 0 rgba(255, 255, 255, 0.6);

      &:hover {
        transform: translateY(-2px) scale(1.02);
        box-shadow: 
          0 8px 24px rgba(0, 0, 0, 0.08),
          inset 0 1px 0 rgba(255, 255, 255, 0.8);
      }

      .impact-score {
        font-size: 56px;
        font-weight: 900;
        line-height: 1;
        margin-bottom: 8px;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        position: relative;

        &.score-excellent {
          background: linear-gradient(135deg, #10b981, #059669);
        }

        &.score-good {
          background: linear-gradient(135deg, #f59e0b, #d97706);
        }

        &.score-needs-improvement {
          background: linear-gradient(135deg, #ef4444, #dc2626);
        }
      }

      .impact-label {
        font-size: 11px;
        font-weight: 600;
        color: #6b7280;
        text-transform: uppercase;
        letter-spacing: 1px;
        margin-bottom: 12px;
      }

      .impact-trend {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 4px 10px;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 600;
        transition: all 0.2s ease;

        .trend-icon {
          transition: transform 0.2s ease;
        }

        &.trend-up {
          background: rgba(16, 185, 129, 0.1);
          color: #065f46;
          border: 1px solid rgba(16, 185, 129, 0.2);
        }

        &.trend-down {
          background: rgba(239, 68, 68, 0.1);
          color: #991b1b;
          border: 1px solid rgba(239, 68, 68, 0.2);
        }

        &:hover .trend-icon {
          transform: scale(1.2);
        }
      }
    }
  }

  // Recognition Section
  .recognition-section {
    display: flex;
    flex-direction: column;
    gap: 32px;

    .peer-recognition {
      .recognition-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        .recognition-title {
          font-size: 14px;
          font-weight: 600;
          color: #374151;
        }

        .recognition-level {
          font-size: 11px;
          font-weight: 600;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.8px;
        }
      }

      .recognition-bars {
        display: flex;
        gap: 8px;

        .recognition-bar {
          height: 6px;
          width: 32px;
          border-radius: 3px;
          background: rgba(0, 0, 0, 0.06);
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;

          &.active {
            background: linear-gradient(135deg, #10b981, #059669);
            box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);
            animation: fillBar 0.6s ease-out forwards;

            &::after {
              content: '';
              position: absolute;
              top: 0;
              left: -100%;
              width: 100%;
              height: 100%;
              background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
              animation: shimmer 1.5s ease-in-out infinite;
            }
          }
        }
      }
    }

    .values-score {
      .values-display {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 16px;
        background: linear-gradient(135deg, rgba(109, 39, 191, 0.06), rgba(139, 69, 255, 0.04));
        border: 1px solid rgba(109, 39, 191, 0.1);
        border-radius: 12px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;
        margin-bottom: 8px;

        &:hover {
          background: linear-gradient(135deg, rgba(109, 39, 191, 0.1), rgba(139, 69, 255, 0.08));
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(109, 39, 191, 0.15);
        }

        .values-number {
          font-size: 20px;
          font-weight: 800;
          color: #6d27bf;
          line-height: 1;
        }

        .values-icon {
          color: #f59e0b;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .values-label {
        font-size: 11px;
        font-weight: 600;
        color: #6b7280;
        text-transform: uppercase;
        letter-spacing: 0.8px;
        text-align: center;
      }
    }
  }

  // Premium tooltip styling
  .tooltip-content {
    padding: 20px;
    max-width: 320px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 
      0 4px 12px rgba(0, 0, 0, 0.1),
      0 20px 40px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(0, 0, 0, 0.04);

    .tooltip-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);

      .tooltip-title {
        font-size: 16px;
        font-weight: 700;
        color: #111827;
      }

      .tooltip-score {
        font-size: 24px;
        font-weight: 900;
        background: linear-gradient(135deg, #6d27bf, #8b5cf6);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    .tooltip-description {
      font-size: 14px;
      color: #6b7280;
      line-height: 1.5;
      margin-bottom: 16px;
    }

    .tooltip-breakdown {
      .breakdown-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.04);

        &:last-child {
          border-bottom: none;
        }

        .breakdown-label {
          font-size: 12px;
          font-weight: 500;
          color: #6b7280;
        }

        .breakdown-value {
          font-size: 12px;
          font-weight: 700;
          color: #111827;
          padding: 2px 8px;
          background: rgba(109, 39, 191, 0.1);
          border-radius: 6px;
        }
      }
    }
  }

  // Custom tooltip popper
  .custom-tooltip {
    .el-tooltip__popper {
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      padding: 0 !important;
    }
  }
}

// Talent Section Styling
.talent-section {
  .section-header {
    padding: 12px 16px;
    border-radius: 8px 8px 0 0;
    margin-bottom: 8px;

    .flex-center {
      gap: 8px;
    }

    .header-icon {
      font-size: 20px;
    }

    .header-title {
      font-size: 16px;
      font-weight: 700;
      color: #15253c;
    }

    .header-count {
      font-size: 14px;
      opacity: 0.6;
      font-weight: 600;
    }

    &.promotion-header {
      background: linear-gradient(135deg, rgba(102, 187, 106, 0.15) 0%, rgba(102, 187, 106, 0.05) 100%);
    }

    &.development-header {
      background: linear-gradient(135deg, rgba(244, 67, 54, 0.15) 0%, rgba(244, 67, 54, 0.05) 100%);
    }

    &.hidden-gems-header {
      background: linear-gradient(135deg, rgba(251, 192, 45, 0.15) 0%, rgba(251, 192, 45, 0.05) 100%);
    }

    &.at-risk-header {
      background: linear-gradient(135deg, rgba(239, 108, 0, 0.15) 0%, rgba(239, 108, 0, 0.05) 100%);
    }
  }

  .section-description {
    font-size: 13px;
    color: rgba(21, 37, 60, 0.7);
    padding: 0 16px 16px;
    line-height: 1.5;
  }

  .talent-cards {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .talent-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    transition: box-shadow 0.2s, transform 0.2s;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
      transform: translateY(-1px);
    }

    .card-top {
      padding: 16px;
      gap: 12px;
      align-items: flex-start;

      .employee-avatar, .employee-avatar-placeholder {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .employee-avatar-placeholder {
        background: linear-gradient(135deg, #6d27bf 0%, #9c4dcc 100%);
        color: #fff;
        font-weight: 700;
        font-size: 16px;
      }

      .employee-info {
        flex: 1;
        min-width: 0;

        .employee-name {
          font-size: 15px;
          font-weight: 700;
          color: #15253c;
          margin-bottom: 6px;
        }

        .employee-role {
          display: flex;
          gap: 6px;
          flex-wrap: wrap;

          .talent-badge, .network-badge {
            font-size: 11px;
            font-weight: 600;
            padding: 4px 10px;
            border-radius: 4px;
            text-transform: uppercase;
            letter-spacing: 0.3px;
          }

          .talent-badge.promotion-talent {
            background: rgba(102, 187, 106, 0.2);
            color: #28642a;
          }

          .talent-badge.development-talent {
            background: rgba(244, 67, 54, 0.2);
            color: #6e1d17;
          }

          .talent-badge.hidden-talent {
            background: rgba(251, 192, 45, 0.2);
            color: #745301;
          }

          .talent-badge.at-risk-talent {
            background: rgba(239, 108, 0, 0.2);
            color: #6f3f16;
          }

          .network-badge {
            background: rgba(0, 0, 0, 0.05);
            color: rgba(0, 0, 0, 0.6);

            &.warning {
              background: rgba(251, 192, 45, 0.15);
              color: #745301;
            }
          }
        }
      }

      .employee-score {
        text-align: right;
        min-width: 90px;

        .score-label {
          font-size: 11px;
          font-weight: 600;
          opacity: 0.6;
          margin-bottom: 4px;
          text-transform: uppercase;
        }

        .score-value {
          font-size: 24px;
          font-weight: 900;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 6px;

          &.promotion-score { color: #66bb6a; }
          &.development-score { color: #f44336; }
          &.hidden-score { color: #fbc02d; }
          &.at-risk-score { color: #ef6c00; }

          .score-trend {
            font-size: 13px;
            font-weight: 700;

            &.up { color: #66bb6a; }
            &.down { color: #f44336; }
          }
        }
      }
    }

    .card-bottom {
      background: rgba(0, 0, 0, 0.02);
      padding: 12px 16px;
      border-top: 1px solid rgba(0, 0, 0, 0.06);

      .achievements-row {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 10px;

        .achievement-label {
          font-size: 12px;
          font-weight: 600;
          opacity: 0.7;
        }

        .flex-center {
          gap: 8px;
        }

        .achievement-item {
          position: relative;
          width: 28px;
          height: 28px;

          img {
            width: 100%;
            height: 100%;
          }

          .badge-count {
            position: absolute;
            top: -4px;
            right: -4px;
            background: #343434;
            color: #fff;
            border-radius: 10px;
            padding: 2px 5px;
            font-size: 10px;
            font-weight: 700;
            line-height: 1;
          }
        }
      }

      .warning-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;
        padding: 8px;
        background: rgba(244, 67, 54, 0.08);
        border-radius: 4px;

        .warning-icon {
          font-size: 16px;
        }

        .warning-text {
          font-size: 12px;
          font-weight: 600;
          color: #d32f2f;
        }
      }

      .recommendation {
        font-size: 13px;
        line-height: 1.4;
        padding: 8px;
        border-radius: 4px;
        font-weight: 500;

        &.promotion-recommendation {
          background: rgba(102, 187, 106, 0.08);
          color: #1b5e20;
        }

        &.development-recommendation {
          background: rgba(244, 67, 54, 0.08);
          color: #b71c1c;
        }

        &.hidden-recommendation {
          background: rgba(251, 192, 45, 0.08);
          color: #e65100;
        }

        &.at-risk-recommendation {
          background: rgba(239, 108, 0, 0.08);
          color: #e65100;
        }
      }
    }

    &.promotion-track-card {
      border-left: 3px solid #66bb6a;
    }

    &.development-track-card {
      border-left: 3px solid #f44336;
    }

    &.hidden-gems-track-card {
      border-left: 3px solid #fbc02d;
    }

    &.at-risk-track-card {
      border-left: 3px solid #ef6c00;
    }
  }

  .show-more-container {
    margin-top: 12px;
    text-align: center;

    .show-more-text {
      display: inline-block;
      padding: 8px 24px;
      cursor: pointer;
      border-radius: 16px;
      background-color: rgba(178, 178, 178, 0.2);
      color: rgba(0, 0, 0, 0.7);
      font-size: 13px;
      font-weight: 600;
      transition: background-color 0.2s;

      &:hover {
        background-color: rgba(178, 178, 178, 0.3);
      }
    }
  }
}

.growing-container {
  .tab-header {
    transition: 0.3s;
    cursor: pointer;
    font-weight: 700;
    margin: auto;
    color: rgba($color: #15253c, $alpha: 0.5);
    position: relative;
    &:before {
      content: "";
      position: absolute;
      height: 2px;
      bottom: -1px;
      transition: 0.3s;
      background-color: #6d27bf;
      width: 0%;
    }
  }
  .tab-header.left {
    &:before {
      left: 100%;
    }
  }
  .tab-header.right {
    &:before {
      right: 100%;
    }
  }
  .tab-header.active-tab {
    color: #6d27bf;
    &:before {
      width: 100%;
    }
  }
  .tab-header.left.active-tab {
    &:before {
      left: 0;
    }
  }
  .tab-header.right.active-tab {
    &:before {
      right: 0;
    }
  }
  .growing-card {
    border-radius: 4px;
    width: 165px;
    height: 80px;
    margin: 4px;
    background-color: rgba($color: #000000, $alpha: 0.03);
    .title {
      font-size: 14px;
      font-weight: 700;
    }
    .value {
      border-radius: 4px;
      font-size: 12px;
      font-weight: 700;
      background-color: #adabb0;
      color: #fff;
      margin-top: 5px;
      padding: 4px 9px 2px;
    }
  }
  .growing-card.Untapped.Potential.highlight,
  .growing-card.Untapped.Potential .value,
  .growing-card.Unsung.Talent.highlight,
  .growing-card.Unsung.Talent .value,
  .growing-card.Engaged.Contributor.highlight,
  .growing-card.Engaged.Contributor .value,
  .growing-card.Emerging.Talent.highlight,
  .growing-card.Emerging.Talent .value,
  .growing-card.Unsung.Talent.highlight,
  .growing-card.Unsung.Talent.value {
    background-color: #fbc02d;
    .value {
      color: #fbc02d;
    }
  }
  .growing-card.Activated.highlight,
  .growing-card.Activated .value,
  .growing-card.Key.Player.highlight,
  .growing-card.Key.Player .value,
  .growing-card.Core.Player.highlight,
  .growing-card.Core.Player .value,
  .growing-card.High.Potential.highlight,
  .growing-card.High.Potential .value {
    background-color: #c2e337;
    .value {
      color: #c2e337;
    }
  }
  .growing-card.High.Performer.highlight,
  .growing-card.High.Performer .value,
  .growing-card.Respected.Expert.highlight,
  .growing-card.Respected.Expert .value,
  .growing-card.Distinguished.Talent.highlight,
  .growing-card.Distinguished.Talent .value,
  .growing-card.Superstar.highlight,
  .growing-card.Superstar .value,
  .growing-card.Solid.Performer.highlight,
  .growing-card.Solid.Performer .value {
    background-color: #66bb6a;
    .value {
      color: #66bb6a;
    }
  }
  .growing-card.Community.Pillar.highlight,
  .growing-card.Community.Pillar .value,
  .growing-card.Up-and-Coming.highlight,
  .growing-card.Up-and-Coming .value,
  .growing-card.Rising.Star.highlight,
  .growing-card.Rising.Star .value,
  .growing-card.Contributor.highlight,
  .growing-card.Contributor .value,
  .growing-card.Crowd.Favorite.highlight,
  .growing-card.Crowd.Favorite .value {
    background-color: #ef8d3a;
    .value {
      color: #ef8d3a;
    }
  }
  .growing-card.Starter.highlight,
  .growing-card.Starter.value,
  .growing-card.Latent.Potential.highlight,
  .growing-card.Latent.Potential .value {
    background-color: #f44336;
    .value {
      color: #f44336;
    }
  }
  .growing-card.highlight {
    color: #fff;
    .value {
      background-color: #fff !important;
    }
  }
  .growing-card.gray-block {
    background-color: #adabb0;
    .title {
      color: #fff;
    }
    .value {
      color: #adabb0;
      background-color: #fff !important;
    }
  }
  .left-text {
    position: absolute;
    top: 200px;
    left: -110px;
    transform: rotate(-90deg);
    font-weight: 700;
    font-size: 16px;
    .left,
    .right {
      position: absolute;
      top: 46%;
      content: "";
      height: 2px;
      background-color: rgba($color: #000000, $alpha: 0.2);
    }
    .left {
      left: -105px;
      width: 90px;
    }
    .right {
      right: -80px;
      content: "";
      width: 65px;
      &:after {
        position: absolute;
        content: "";
        top: -4px;
        right: -24px;
        border: 12px solid rgba($color: #000000, $alpha: 0.2);
        border-width: 5px 12px;
        border-color: transparent transparent transparent
          rgba($color: #000000, $alpha: 0.2);
      }
    }
  }
  .line-label {
    width: 100%;
    margin-left: auto;
    text-align: center;
    border-bottom: 2px solid rgba($color: #000000, $alpha: 0.2);
    line-height: 0.1em;
    margin: 10px 0 10px;
  }

  .line-label span.label {
    background: #fff;
    padding: 0 16px;
  }
  .line-label span.arrow {
    position: absolute;
    content: "";
    height: 0;
    right: 18px;
    content: "";
    width: 0;
    &:after {
      position: absolute;
      content: "";
      top: -3px;
      right: -24px;
      border: 12px solid rgba($color: #000000, $alpha: 0.2);
      border-width: 5px 12px;
      border-color: transparent transparent transparent
        rgba($color: #000000, $alpha: 0.2);
    }
  }
  .profile-card {
    box-shadow: 0 3px 6px #00000029;
    border-radius: 6px;
    .profile {
      border: 1px solid #00000033;
      padding: 12px;
    }
    .profile.top {
      border-radius: 6px 6px 0 0;
      border-width: 1px 1px 0 1px;
      .talent {
        padding: 7px 16px 5px;
        border-radius: 16px;
        color: #ffffff;
        text-transform: uppercase;
        font-size: 11px;
        font-weight: 700;
        font-family: "Lato", sans-serif;
        margin-left: 14px;
      }
      .talent.old {
        background-color: rgba($color: #000000, $alpha: 0.3);
      }
      .talent.now {
        background-color: #6d27bf;
      }
    }
    .profile.bottom {
      border-radius: 0 0 6px 6px;
      border-width: 0 1px 1px 1px;
      background-color: rgba($color: #000000, $alpha: 0.04);
      // .excels-at {
      //   color: #fff;
      //   background-color: #0caca5;
      //   font-weight: 700;
      //   height: 26px;
      //   border-radius: 4px;
      //   margin-top: 4px;
      //   margin-bottom: 4px;
      //   .text {
      //     padding: 6px 8px 5px;
      //     font-size: 13px;
      //   }
      //   .value {
      //     font-size: 11px;
      //     border-radius: 0 4px 4px 0;
      //     padding: 7px 10px 5px;
      //     background-color: rgba($color: #000000, $alpha: 0.3);
      //   }
      // }
      // .star-truly {
      //   position: relative;
      //   font-family: "Lato", sans-serif;
      //   .star {
      //     width: 32px;
      //     height: 32px;
      //     border-radius: 32px;
      //     background-color: grey;
      //   }
      //   .value {
      //     position: absolute;
      //     bottom: 0;
      //     left: 18px;
      //     background-color: #f22f3c;
      //     width: 18px;
      //     height: 16px;
      //     border-radius: 18px;
      //     color: #fff;
      //     font-weight: 700;
      //     font-size: 12px;
      //     padding-top: 2px;
      //   }
      // }
      .achievements-contariner {
        width: 32px;
        margin-right: 6px;
        position: relative;
        .count-icon {
          position: absolute;
          top: -4px;
          right: -4px;
          height: 16px;
          min-width: 16px;
          padding: 0 1px;
          text-align: center;
          border-radius: 32px;
          background-color: #343434;
          color: #ffffff;
          font-size: 11px;
          font-weight: 700;
          line-height: 19px;
        }
      }
      .achievements-contariner.no-have {
        opacity: 0.2;
        > img {
          filter: grayscale(100%);
        }
      }
      .cell.c-FBC02D {
        background: #fbc02d;
      }
      .cell.c-C2E337 {
        background: #c2e337;
      }
      .cell.c-66BB6A {
        background: #66bb6a;
      }
      .cell.c-EF8D3A {
        background: #ef8d3a;
      }
      .cell.c-F44336 {
        background: #f44336;
      }
    }
  }
  .show-more-text {
    padding: 8px 24px;
    cursor: pointer;
    border-radius: 16px;
    background-color: rgba($color: #b2b2b2, $alpha: 0.3);
    color: rgba($color: #000000, $alpha: 0.7);
  }
}
.talent-tag {
  width: 96px;
  padding: 4px 12px;
  font-size: 13px;
  font-weight: 700;
  border-radius: 4px;
}
// Talent badge styles
.talent-excellent {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.12), rgba(5, 150, 105, 0.08));
  color: #065f46;
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.talent-good {
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.12), rgba(217, 119, 6, 0.08));
  color: #92400e;
  border: 1px solid rgba(245, 158, 11, 0.2);
}

.talent-developing {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(220, 38, 38, 0.08));
  color: #991b1b;
  border: 1px solid rgba(239, 68, 68, 0.2);
}

.tag-red {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(220, 38, 38, 0.08));
  color: #991b1b;
  border: 1px solid rgba(239, 68, 68, 0.15);
}
.tag-half-red {
  background: linear-gradient(135deg, rgba(249, 115, 22, 0.12), rgba(234, 88, 12, 0.08));
  color: #9a3412;
  border: 1px solid rgba(249, 115, 22, 0.15);
}
.tag-orange {
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.12), rgba(217, 119, 6, 0.08));
  color: #92400e;
  border: 1px solid rgba(245, 158, 11, 0.15);
}
.tag-half-green {
  background: linear-gradient(135deg, rgba(132, 204, 22, 0.12), rgba(101, 163, 13, 0.08));
  color: #365314;
  border: 1px solid rgba(132, 204, 22, 0.15);
}
.tag-green {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.12), rgba(5, 150, 105, 0.08));
  color: #065f46;
  border: 1px solid rgba(16, 185, 129, 0.15);
}
.impact-tag {
  padding: 1px 0px 0px;
  text-align: center;
  width: 52px;
  height: 32px;
  border-radius: 4px;
  font-size: 15px;
}
.impact-tag-red {
  background-color: rgba(#f44336, 0.3);
  color: #6e1d17;
}
.impact-tag-yellow {
  background-color: rgba(#fbc02d, 0.3);
  color: #745301;
}
.impact-tag-green {
  background-color: rgba(#66bb6a, 0.3);
  color: #28642a;
}
// Animations
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes fillBar {
  0% { transform: scaleX(0); }
  100% { transform: scaleX(1); }
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

.tooltop {
  padding: 6px;
  width: 350px;
}
</style>
